import React, { useEffect, useState } from "react";
import { Context as dataContext } from "../providers/dataProvider";
import { Context as scoutSessionContext } from "../providers/scoutSessionProvider";
import { SubmitData } from "../apis/backend";
import SubmitPage from "./submitPage";

import * as comp from "./tiles";

export const PageGenerator = ({layouts}: {layouts: any}) => {
    const { addData, changeData, getData, getAllData } = React.useContext(dataContext);
    const { type, team, match } = React.useContext(scoutSessionContext);
    const [activeSheet, setActiveSheet] = useState(layouts.sheets.find((sheet: any) => sheet.default).name)
    const [submitPage, setSubmitPage] = useState<Boolean>(false)
    
    const [sheets, setSheets] = useState<React.FC[]>([])

    useEffect(() => {
        setSheets(
            layouts.sheets.map((sheet: any, index: number) => {
                return (
                    <div key={index}>
                        {sheet.components.map((component: any) => {
                            return <Container key={index} component={component}/>
                        })}
                    </div>
                )
            })
        )
    }, [])

    function Submit() {
        const data = getAllData()
        console.log("Submit")
        console.log("Type: " + type)
        console.log("Team: " + team)
        console.log("Match: " + match)
        console.log("Data: " + JSON.stringify(data))
        SubmitData(
            type,
            type === "match" ?
                {
                    team: team,
                    match: match,
                    data: data
                } :
                {
                    team: team,
                    data: data
                }
        )
    }

    // Each individual components container
    const Container = ({component}: {component: any}) => {
        // Gets the type of the component, empty div is needed for type checking
        const Defualt = () => <div/> 
        const Component = comp.Lib(component.type || "") || Defualt;

        // If the component is not found, return an empty div. Removal causes type error
        if (!Container) {
            return <div />;
        }

        // Gets the props for the elements and its children
        const children = component.children || [];
        const props = component.props || {};
        const tagline = component.tag || "";
        const tag = tagline.split("|");
        
        //Tag "switch-" is used to switch between sheets
        if (tag[0] === "switch") {
            props.onChange = () => {
                setActiveSheet(tag[1])
                console.log("triggered")
            }
            console.log(tag[1])
        }
        
        //Tag "data-" is used to store data
        if (tag[0] === "data") {
            addData(tag[1], tag[2])
            // Adds the change function to the component
            props.value = getData(tag[1])
            props.onChange = (value: any) => {
                changeData(tag[1], value)
            }
        }
        if (tag[0] === "dataint") {
            // Add the reference to the global state
            addData(tag[2], 0)
            // Adds the change function to the component
            props.value = getData(tag[2])
            props.onChange = () => {
                const original = getData(tag[2])
                changeData(tag[2], original + tag[1])
            }
        }

        //Tag "submit-" is used to submit data
        if (tag[0] === "submit") {
            props.onChange = () => {
                Submit()
                setSubmitPage(true)
            }
        }

        return (
            <Component {...props}>
                {children.map((child: any, index: number) => (
                    <Container key={index} component={child} />
                ))}
            </Component>
        );
    };

    console.log(activeSheet)

    return (
        <div>
            <div
                style={{
                    position: "absolute",
                    top: "0",
                    left: "50%",
                }}
            >
                <h1>{activeSheet}</h1>
            </div>
            {sheets.map((Sheet: any, index: number) => {
                return (
                    <div key={index} style={{ display: layouts.sheets[index].name === activeSheet && !submitPage ? 'block' : 'none'}}>
                        <>{Sheet}</>
                    </div>
                )
            })}
            <div style={{ display: submitPage ? 'block' : 'none'}} >
                <SubmitPage submit={() => Submit()}/>
            </div>
        </div>
    )
}